import { type ObjectValuesUnionType } from '../../utils/typing';

export const RuntimeActionTypes = Object.freeze({
  REFRESH_KEEPALIVE: 'RUNTIME:REFRESH_KEEPALIVE',
  REFRESH_KEEPALIVE_OK: 'RUNTIME:REFRESH_KEEPALIVE_OK',
  REFRESH_KEEPALIVE_KO: 'RUNTIME:REFRESH_KEEPALIVE_KO',

  INCREMENT_HISTORY_LENGHT: 'RUNTIME:INCREMENT_HISTORY_LENGHT',
  SET_LICENCE: 'RUNTIME:SET_LICENCE',
  SET_WEBSOCKET_IS_CONNECTED: 'RUNTIME:SET_WEBSOCKET_IS_CONNECTED',
  SET_OVERRIDE_SETTINGS: 'RUNTIME:SET_OVERRIDE_SETTINGS',
});

export type RuntimeActionType = ObjectValuesUnionType<typeof RuntimeActionTypes>;
